import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./shell/shell.css";
import "./auth/auth.css";
import "./settings/settings.css";
import "./subscriptions/subscriptions.css";
import "./documents/documents.css";
import "./research/writing-assistant/writing.css";
import { render } from "preact";
import { App } from "./shell/App";
import { startRouter } from "./shell/router";
import { applyTheme, readTheme } from "./shell/theme";

/** The component sheet's address. Development only: see below. */
const SHEET_PATH = "/__components";

// public/theme-boot.js has already set the theme before first paint. This
// repeats it so a build served without that file still honours the choice.
applyTheme(readTheme());

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root to render into.");

// The component sheet (day 32), in development only. import.meta.env.DEV is
// false in a production build, so this branch and the sheet's module are left
// out of it; `npm run drill:sheet` checks the built bundle for them.
if (import.meta.env.DEV && window.location.pathname === SHEET_PATH) {
  void import("./dev/ComponentSheet").then(({ mountSheet }) => mountSheet(root));
} else {
  startRouter();
  render(<App />, root);
}
